import { doBootstrapOnboarding } from '../../actions'
import { doUpdateCompanyProfile } from '../../ducks/companyProfile/operations'
import { V6_COMPANY_2_PAGE } from '../../pages'

export const doSaveAndRedirect = fields => async dispatch => {
  const companyFields = {
    name: fields.companyName,
    websiteUrl: fields.websiteUrl,
    industry: fields.industry,
    hearAboutUs: fields.hearAboutUs,
  }

  await dispatch(doUpdateCompanyProfile(companyFields))
  // HACK (jscheel): Because updating the company profile can change the
  // subdomain, we need to get the new subdomain back. This really should
  // come from the backend response, but in the interest of time, just doing
  // an extra request here to get this out.
  await dispatch(doBootstrapOnboarding())
  return dispatch({
    type: V6_COMPANY_2_PAGE,
  })
}
